import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './dot.module.scss';

const METADATA = Metadata.define({
  description: 'Notification dot badge indicator.',
  name: 'Dot Notification Badge',
});

export default class SpdsIndicatorBadgeDotNotification extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-badge-dot';
  variantClass = 'spds-indicator-badge-dot-notification';
  variantStyles = styles;
}

export const BADGE_DOT_NOTIFICATION_METADATA = SpdsIndicatorBadgeDotNotification.metadata;
